export const environment = {
  production: true,
  /*contractTypeApiURL: 'https://localhost:44307',
  //  contractApiURL:'http://localhost:8080',*/

  // contractTypeApiURL: 'https://clmdev.sundeus.com/contracttype/api', //.net
  // contractApiURL: 'https://clmdev.sundeus.com/contract/api', //java

  // Both APIs are proxied by nginx on the same domain (clm.sundeus.com),
  // so relative URLs work over both HTTP and HTTPS — no rebuild needed
  // when switching to certbot/HTTPS.
  // (/contracttype/api -> :8080/api  |  /contract/api -> :8081/api1)
  contractTypeApiURL: '/contracttype/api', //.net
  contractApiURL: '/contract/api', //java

  // contractTypeApiURL: 'http://35.189.94.89:8080/api', //.net
  // contractApiURL: 'http://35.189.94.89:8081/api1', //java

  firebaseConfig: {
    apiKey: "AIzaSyCVL20Aq64fHq1_ZHaT5JyL8EIwkzLGC7M",
    authDomain: "contract-management-8efc2.firebaseapp.com",
    databaseURL: "https://contract-management-8efc2.firebaseio.com",
    projectId: "contract-management-8efc2",
    storageBucket: "contract-management-8efc2.appspot.com",
    messagingSenderId: "700226026605",
    appId: "1:700226026605:web:9eeef30b2503e18d"
  }
};
